import React from 'react'

const CreditScoreProgressBar = ({ score, maxScore = 850 }) => {
  const percentage = score ? Math.min(100, (score / maxScore) * 100) : 0

  const gradient = [
    { color: '#001133', position: '0%' }, // Very dark blue/black
    { color: '#002766', position: '40%' }, // Dark blue
    { color: '#0058F0', position: '100%' }, // Primary blue
  ]
  const primaryBlue = '#0058F0'
  const gradientBackground = `linear-gradient(to right, ${gradient.map(g => `${g.color} ${g.position}`).join(', ')})`

  const getStatusInfo = score => {
    if (!score) return { text: 'N/A', color: '#6c757d' }
    if (score < 580) return { text: 'very poor', color: '#dc3545' }
    if (score < 670) return { text: 'poor', color: '#fd7e14' }
    if (score < 740) return { text: 'good', color: '#4CDB6A' }
    if (score < 800) return { text: 'very good', color: '#4CDB6A' }
    return { text: 'excellent', color: '#4CDB6A' }
  }

  const statusInfo = getStatusInfo(score)

  return (
    <div className='credit-score-container'>
      <div
        className='progress-container position-relative mb-4 mx-auto'
        style={{ maxWidth: '800px', width: '100%' }}
      >
        <div
          className='w-100'
          style={{
            height: '10px',
            borderRadius: '5px',
            background: gradientBackground,
            position: 'relative',
          }}
        />

        {/* Large blue triangle marker with white border at the current score position */}
        <div
          className='position-absolute'
          style={{
            left: `${percentage}%`,
            top: '-25px',
            transform: 'translateX(-50%)',
            zIndex: 1,
          }}
        >
          <svg
            width='40'
            height='28'
            viewBox='0 0 40 28'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M20 28L0.5 0.5H39.5L20 28Z'
              fill={primaryBlue}
              stroke='white'
              strokeWidth='1'
            />
          </svg>
        </div>
      </div>

      <div className='score-status text-center mt-3'>
        <p className='mb-0 text-secondary' style={{ fontSize: '1.1rem' }}>
          Your score is{' '}
          <span style={{ color: statusInfo.color, fontWeight: '500' }}>{statusInfo.text}</span>
        </p>
      </div>
    </div>
  )
}

export default CreditScoreProgressBar
